import { createContext, useCallback, useContext, useMemo, useState } from "react";

const ModalContext = createContext();

export const ModalProvider  = ({ children }) => {

    const [ modalStack, setModalStack ] = useState([]);

    // Evita empilhar o mesmo id mais de uma vez (Strict Mode / reabertura).
    const openModal = useCallback(
        ( id ) => setModalStack(( stack ) => (
            stack.includes( id ) ? stack : [ ...stack, id ]
        )),
        []
    );

    // Sem argumento (ou evento de click): fecha o topo.
    // Com id string: remove todas as ocorrências daquele modal.
    const closeModal = useCallback(
        ( id ) => setModalStack(( stack ) => {
            if ( typeof id === "string" ) {
                return stack.filter(( item ) => item !== id );
            }
            return stack.slice( 0, Math.max( 0, stack.length - 1 ) );
        }),
        []
    );

    const isModalOpen = useCallback(
        ( id ) => modalStack.includes( id ),
        [ modalStack ]
    );
    const getTopModal = useCallback(
        () => modalStack[ modalStack.length - 1 ],
        [ modalStack ]
    );

    const clearAllModal = useCallback(() => setModalStack([]), []);

    const value = useMemo(
        () => ({ isModalOpen, openModal, closeModal, getTopModal, clearAllModal }),
        [ isModalOpen, openModal, closeModal, getTopModal, clearAllModal ]
    );

    return(
        <ModalContext.Provider value={ value } >
            { children }
        </ModalContext.Provider>
    )

}

export const useModal = () => useContext( ModalContext )